import { http } from "../../utils/config";

const categoryAPI = {
  // Lấy danh sách danh mục (hỗ trợ phân trang, tìm kiếm)
  getList: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      sort_by = 'created_at',
      sort_order = 'desc',
      is_tree = false
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      is_tree: is_tree.toString(),
      ...(search && { search })
    });

    return http.get(`/api/v1/categories?${queryParams}`);
  },

  // Lấy chi tiết danh mục
  getById: (id) => {
    return http.get(`/api/v1/categories/${id}`);
  },

  // Tạo mới danh mục
  create: (data) => {
    return http.post('/api/v1/categories', data);
  },

  // Cập nhật danh mục
  update: (id, data) => {
    return http.put(`/api/v1/categories/${id}`, data);
  },

  // Xóa danh mục
  delete: (id) => {
    return http.delete(`/api/v1/categories/${id}`);
  },

  // Bật/tắt trạng thái
  toggleStatus: (id) => {
    return http.patch(`/api/v1/categories/${id}/toggle-status`);
  }
};

// Error handling wrapper helper (optional if using withErrorHandling elsewhere)
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response.data; // Return only data part of axios response
    } catch (error) {
      console.error('API Error:', error);
      if (error.response && error.response.data) {
        throw error.response.data;
      }
      throw new Error(error.message || 'Đã có lỗi xảy ra');
    }
  };
};

export const categoryAPIWithErrorHandling = {
  getList: withErrorHandling(categoryAPI.getList),
  getById: withErrorHandling(categoryAPI.getById),
  create: withErrorHandling(categoryAPI.create),
  update: withErrorHandling(categoryAPI.update),
  delete: withErrorHandling(categoryAPI.delete),
  toggleStatus: withErrorHandling(categoryAPI.toggleStatus),
};

export default categoryAPI;
